import { useGlobalContext } from './useGlobalContext';

const useMainPage = () => {
  const { state: { tenancy } } = useGlobalContext();
  const mainPage = tenancy?.settings?.site?.mainPage;

  return mainPage;
};

export default useMainPage;